var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconionicMdInformationCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-info",
    "data-name": "Icon feather-info",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_750",
    "data-name": "Trazado 750",
    d: "M33,18A15,15,0,1,1,18,3,15,15,0,0,1,33,18Z",
    fill: "none",
    stroke: "#b2a169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_751",
    "data-name": "Trazado 751",
    d: "M18,24V18",
    fill: "none",
    stroke: "#b2a169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_752",
    "data-name": "Trazado 752",
    d: "M18,12h0",
    fill: "none",
    stroke: "#b2a169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicMdInformationCircleOutline);
export default __webpack_public_path__ + "static/media/Icon ionic-md-information-circle-outline.5fca11cb7af32205401bb47c6a370522.svg";
export { ForwardRef as ReactComponent };